{
  "version": 1,
  "asset_id": "c1a4c35a-b4ef-4fb2-bea5-25c933147f2e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c1a4c35a-b4ef-4fb2-bea5-25c933147f2e/white-metal-roof-crystal-river-fl-1600.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c1a4c35a-b4ef-4fb2-bea5-25c933147f2e/white-metal-roof-crystal-river-fl-1600.avif",
  "original_filename": "white-metal-roof-crystal-river-fl-1600.avif",
  "size": 58611,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:36:07Z"
}
